export default {"src":"/_next/static/media/ASSISTENCIA_SOCIAL.17474852.gif","height":640,"width":640,"blurWidth":0,"blurHeight":0};